import React from 'react'

import { s360ConfigService } from '../../Simplify360Chat/Services/S360Config'

import './ChatLoader.css'

export default function ChatLoader() {
  const config = s360ConfigService?.config;
  const loaderStyle= ()=> {
    return {
      backgroundColor: "#941f80",
      ...config?.customDesign?.chatLoader
    }
  }

  return (
    <div className="loader">
      <span className="loader-s360-text">Loading..</span>
      <div className="loader-inner ball-pulse">
        <div style={loaderStyle()}></div>
        <div style={loaderStyle()}></div>
        <div style={loaderStyle()}></div>
      </div>
    </div>
  );
}
